const list = {
  name: 'list',
  method: 'get',
};

const create = {
  name: 'create',
  method: 'post',
  url: '/api/scenarios',
};

const createMany = {
  name: 'createMany',
  method: 'post',
  url: 'create-many',
};

const update = {
  name: 'update',
  method: 'patch',
  url: ':id',
};

const getOne = {
  name: 'getOne',
  method: 'get',
  url: ':scenarioId',
};

const listWithParams = {
  name: 'listWithParams',
  method: 'get',
  url: 'list',
};

const getListByIds = {
  name: 'getListByIds',
  method: 'post',
  url: 'list-by-ids',
};

const remove = {
  name: 'remove',
  method: 'delete',
  url: ':scenarioId',
};

const restore = {
  name: 'restore',
  method: 'post',
  url: ':scenarioId/restore',
};

const getVersions = {
  name: 'getVersions',
  method: 'get',
  url: 'version/:id/versions-list',
};

const getVersionData = {
  name: 'getVersionData',
  method: 'get',
  url: 'version/:versionId/',
};

const getVersionTags = {
  name: 'getVersionTags',
  method: 'get',
  url: 'version/:versionId/tags',
};

const updateVersionTags = {
  name: 'updateVersionTags',
  method: 'post',
  url: 'version/:versionId/tags',
};

const createVersion = {
  name: 'createVersion',
  method: 'post',
  url: 'version/:id/',
};

const getRatingList = {
  name: 'getRatingList',
  method: 'get',
  url: 'rate/list',
};

const downloadRatings = {
  name: 'downloadRatings',
  method: 'get',
  url: 'rate/download',
  options: {
    responseType: 'blob',
  },
};

const createDraft = {
  name: 'createDraft',
  method: 'post',
  url: 'draft/:id',
};

const getDraft = {
  name: 'getDraft',
  method: 'get',
  url: 'draft/:id',
};

const rejectDraft = {
  name: 'rejectDraft',
  method: 'post',
  url: 'draft/:id/reject',
};

const approveDraft = {
  name: 'approveDraft',
  method: 'post',
  url: 'draft/:id/approve',
};

const updateDraft = {
  name: 'updateDraft',
  method: 'patch',
  url: 'draft/:id',
};

const changeWorkspace = {
  name: 'changeWorkspace',
  method: 'post',
  url: 'change-workspace',
};

const unbindTag = {
  name: 'unbindTag',
  method: 'post',
  url: 'unbind-tag',
};

const bindTag = {
  name: 'bindTag',
  method: 'post',
  url: 'bind-tag',
};

const replaceTag = {
  name: 'replaceTag',
  method: 'post',
  url: 'replace-tag',
};

const getSyncedSimulation = {
  name: 'getSyncedSimulation',
  method: 'get',
  url: ':scenarioId/simulation-sync',
};

export default {
  name: 'scenarios',
  url: '/api/scenarios',
  children: [
    list,
    create,
    createMany,
    update,
    getOne,
    listWithParams,
    remove,
    restore,
    getListByIds,
    getVersions,
    getVersionData,
    createVersion,
    getVersionTags,
    updateVersionTags,
    getRatingList,
    createDraft,
    getDraft,
    rejectDraft,
    approveDraft,
    updateDraft,
    changeWorkspace,
    unbindTag,
    bindTag,
    replaceTag,
    downloadRatings,
    getSyncedSimulation,
  ],
};
